import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Image, Shadow, GridItem, MaxWidth, Rectangle, Space } from '@pitchero/react-ui';
import { find } from 'lodash';

const ProductImages = ({ images = [], productName }) => {
  const [activeImage, setActiveImage] = useState(() =>
    images.length > 0 ? find(images, { id: images[0].id }) : { id: '', url: '' },
  );

  return (
    <MaxWidth maxWidth={400} style={{ margin: '0 auto' }}>
      <GridItem alignSelf="baseline">
        <Shadow shadow="dark">
          <Rectangle fill="white">
            <Image
              src={activeImage.url}
              alt={productName}
              fullWidth
              loadingAspectRatio={1}
              shimmerOnLoad
              style={{ display: 'block' }}
              responsive={[
                { minWidth: 'tab', props: { width: 300 } },
                { minWidth: 'lap', props: { width: 400 } },
              ]}
            />
          </Rectangle>
        </Shadow>
        {images.length > 1 && (
          <Space top="medium">
            <Grid columns="repeat(3, 1fr)" columnGap="small" rowGap="small">
              {images.map((image) => (
                <Shadow shadow="dark" key={image.id}>
                  <Image
                    onClick={() => setActiveImage(image)}
                    src={image.url}
                    alt={productName}
                    loadingAspectRatio={1}
                    shimmerOnLoad
                    style={{
                      cursor: 'pointer',
                      display: 'block',
                      opacity: image === activeImage ? 0.6 : 1,
                    }}
                    fullWidth
                    height={125}
                    width={125}
                    transformation="square"
                  />
                </Shadow>
              ))}
            </Grid>
          </Space>
        )}
      </GridItem>
    </MaxWidth>
  );
};

ProductImages.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ).isRequired,
  productName: PropTypes.string.isRequired,
};

export default ProductImages;
